<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title" v-encode="pageTitle"></h1>
          </div>
        </div>
      </div>
      <div class="m-content m-content-ls">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div v-if="configuration.visitrecorder.enabled">
              <div class="row" v-if="status === 0">
                <div class="col-sm-12">
                  <div class="intro mb-5" v-html="configuration.visitrecorder.welcome"></div>
                  <qr-code-scanner
                    v-bind:qrbox="250"
                    v-bind:fps="10"
                    @scan="onScan">
                  </qr-code-scanner>
                  <p><input v-model="code" type="text" id="code" name="code" :placeholder="$t('Enter code manually')" class="code-input" /></p>
                  <p><button @click="onSubmit" class="btn btn-ls code-submit">{{$t('Submit code')}}</button></p>
                </div>
              </div>
              <div class="row" v-if="status === 1">
                <div class="col-sm-12 text-center mb-4">
                  <h3>{{$t('Waiting for code confirmation')}} {{ code }}</h3>
                </div>
                <div class="col-sm-12">
                  <div class="intro">
                    {{$t('Scan code info')}}
                  </div>
                  <div class="text-center mt-5">
                    <spinner></spinner>
                  </div>
                </div>
              </div>
              <div class="row" v-if="status === 2">
                <div class="col-sm-12 text-center mb-4">
                  <h3>{{$t('Thanks for visit')}}</h3>
                </div>
                <div class="col-sm-12">
                  <div class="intro" v-html="configuration.visitrecorder.thankyou"></div>
                  <div class="text-center mt-5">
                    <span class="points">+ {{ configuration.visitrecorder.points }} {{ pointsSymbol }}</span>
                  </div>
                  <div class="col-sm-12 mt-5">
                    <button @click="onReset" class="btn btn-ls code-submit">{{$t('Scan new code')}}</button>
                  </div>
                </div>
              </div>
              <div class="row" v-if="status === 3">
                <div class="col-sm-12 text-center mb-4">
                  <h3>{{$t('Visit rejected')}}</h3>
                </div>
                <div class="col-sm-12">
                  <div class="intro">
                    {{$t('Visit rejected by seller')}}
                  </div>
                </div>
                <div class="col-sm-12 mt-5">
                  <button @click="onReset" class="btn btn-ls code-submit">{{$t('Scan new code')}}</button>
                </div>
              </div>
            </div>
            <div class="row" v-if="!configuration.visitrecorder.enabled">
              <div class="col-sm-12 text-center">
                <p>{{$t('Disabled visit registration')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import Encode from "@/directives/encode";
import Page from "./Page";
import QrCodeScanner from "../qrcode/QrCode"
import PageTitle from "@/mixins/pageTitle";
import Spinner from "@/components/spinner/Spinner";
import {mapActions, mapState} from "vuex";
import axios from 'axios';

export default {
  name: "VisitrecorderPage",
  data: function () {
    return {
      code: '',
      status: 0,
      checkLoop: null
    };
  },
  components: {QrCodeScanner, Page, Spinner},
  directives: {Encode},
  mixins: [PageTitle('Zeskanuj kod')],
  created() {
    this.fetchVisitrecorder()
      .then(() => {
        const queryCode = typeof this.$route.query.code === 'string' ? this.$route.query.code : '';
        const shouldAutoSubmit = this.$route.query.autoSubmit === '1';

        if (queryCode) {
          this.code = queryCode;

          if (shouldAutoSubmit && this.configuration.visitrecorder.enabled && this.status === 0) {
            this.stripAutoSubmitQuery();
            this.onSubmit();
          }
        }
      })
      .catch((error) => {
        if (418 === error.response.status) {
          this.configuration.visitrecorder.enabled = false;
        }
      });
  },
  beforeMount() {
    // Ochrona route'a leży w router.beforeEach (gui/member/src/router/index.js),
    // który zapisuje fullPath przez storePostLoginRedirect i pcha na /login.
    // Lokalny logout() tutaj nadpisywałby ten flow i gubił kod z query string.
  },
  beforeDestroy() {
    this.clearCheck();
  },
  methods: {
    ...mapActions(['fetchVisitrecorder']),
    onScan(decodedText) {
      this.code = this.getCodeFromLink(decodedText);
      this.onSubmit(decodedText);
    },
    onReset() {
      this.status = 0;
    },
    onSubmit() {
      axios.post('/visitrecorder', {code: this.code})
        .then(() => {
          this.status = 1;
          this.onCheck(this.code);
        })
        .catch((error) => {
          if (418 === error.response.status) {
            this.configuration.visitrecorder.enabled = false;
          }
        })
    },
    onCheck(code) {
      let $this = this;
      let loopCount = 0;
      this.checkLoop = setInterval(function () {
        axios.get('/visitrecorder/check/' + code)
          .then((res) => {

            if ('confirmed' === res.data.state) {
              $this.status = 2;
            } else if ('rejected' === res.data.state) {
              $this.status = 3;
            }

            loopCount++;

            if (loopCount >= 60) {
              clearInterval($this.checkLoop);
            }
          })
          .catch((error) => {
            if (418 === error.response.status) {
              this.configuration.visitrecorder.enabled = false;
            }
          });
      }, 5000);
    },
    clearCheck() {
      if (null !== this.checkLoop) {
        clearInterval(this.checkLoop);
        this.checkLoop = null;
      }
    },
    stripAutoSubmitQuery() {
      const query = { ...this.$route.query };
      if (!('autoSubmit' in query) && !('code' in query)) {
        return;
      }
      delete query.autoSubmit;
      delete query.code;
      this.$router.replace({ path: this.$route.path, query }).catch(() => {});
    },
    getCodeFromLink(decodedText) {
      try {
        const url = new URL(decodedText);
        const pathParts = url.pathname.split('/').filter(part => part.length > 0);
        const codeIndex = pathParts.indexOf('c');

        if (codeIndex !== -1 && pathParts[codeIndex + 1]) {
          return pathParts[codeIndex + 1];
        }

        return decodedText;
      } catch (e) {
        return decodedText;
      }
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.visitrecorder,
      pointsConfig: state => state.settings.points,
    }),
    pointsSymbol() {
      return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
    },
  },
  watch: {
    status: function(value) {
      if (1 !== value) {
        this.clearCheck();
      }

      if (0 === value) {
        this.code = '';
      }
    }
  },
}
</script>

<style>
.intro {
  text-align: center;
}
.code-input {
  width: 100%;
  border: 2px solid gray;
  margin-top: 1rem;
  padding: 12px 6px;
  border-radius: 12px;
  text-align: center;
  text-transform: uppercase;
}
.code-input:focus {
  outline: none;
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.code-submit{
  width: 100%;
  border-radius: 12px !important;
  padding: 12px 6px;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
}
.points {
  background-color: var(--accent-color) !important;
  padding: 1.2rem;
  color: #fff;
  font-weight: 500;
  font-size: 2rem;
  text-align: center;
  border-radius: 30px;
}
</style>
